import { defaultConfigService } from "../../services/defaultConfig.service";
import { DefaultConfigModuleConstant } from "../constants/DefaultConfig.constant";

const getWalletThresholdDefaultsPending = () => ({
    type: DefaultConfigModuleConstant.WALLET_THRESHOLD_DEFAULTS_PENDING,
});
const getWalletThresholdDefaultsFailed = () => ({
    type: DefaultConfigModuleConstant.WALLET_THRESHOLD_DEFAULTS_FAILURE,
});
const getWalletThresholdDefaultsSuccess = (response) => ({
    type: DefaultConfigModuleConstant.WALLET_THRESHOLD_DEFAULTS_SUCCESS,
    payload: response,
});

export const fetchWalletThresholdDefaults = () => {
    return (dispatch) => {
        dispatch(getWalletThresholdDefaultsPending());
        defaultConfigService.getWalletThresholdDefaults().then((result) => {
            dispatch(getWalletThresholdDefaultsSuccess(result.data));
        }).catch(() => {
            dispatch(getWalletThresholdDefaultsFailed());
        });
    };
};

export const updateWalletThresholdDefaults = (data) => {
    return () => {
        return defaultConfigService.updateWalletThresholdDefaults(data);
    };
};

const getConfigurationDefaultsPending = () => ({
    type: DefaultConfigModuleConstant.CONFIGURATION_DEFAULTS_PENDING,
});
const getConfigurationDefaultsFailed = () => ({
    type: DefaultConfigModuleConstant.CONFIGURATION_DEFAULTS_FAILURE,
});
const getConfigurationDefaultsSuccess = (response) => ({
    type: DefaultConfigModuleConstant.CONFIGURATION_DEFAULTS_SUCCESS,
    payload: response,
});

export const fetchConfigurationDefaults = () => {
    return (dispatch) => {
        dispatch(getConfigurationDefaultsPending());
        defaultConfigService.getConfigurationDefaults().then((result) => {
            dispatch(getConfigurationDefaultsSuccess(result.data));
        }).catch(() => {
            dispatch(getConfigurationDefaultsFailed());
        });
    };
};

export const updateConfigurationDefaults = (data) => {
    return () => {
        return defaultConfigService.updateConfigurationDefaults(data);
    };
};
